export { TikTokIcon } from './tiktok'
